import React, { useState } from 'react'
import { ChipSelector } from '@/components/donation'
import {
  SubSection,
  StyledDemoGrid,
  DemoComponent,
  StyledSizeLabel,
} from '../styled.jsx'

const demoChips = [
  { id: 'rbc', text1: 'Red Blood Cells', text2: 'Full' },
  { id: 'wbc', text1: 'White Blood Cells', text2: '10 Openings' },
  { id: 'wb', text1: 'Whole Blood', text2: '6 Openings' },
  { id: 'plt', text1: 'Platelets', text2: '4 Openings' },
]

export const ChipSelectorSection = () => {
  const [selected, setSelected] = useState('wb')
  const [readonly, setReadonly] = useState('rbc')

  return (
    <>
      <SubSection
        title='Chip Selector'
        description='Pick one option from chips styled as buttons'
      >
        <StyledSizeLabel variant='h6' gutterBottom>
          Basic
        </StyledSizeLabel>
        <StyledDemoGrid>
          <DemoComponent
            label='Interactive'
            component={
              <ChipSelector
                id='demo-chip-selector'
                title='09:00 AM'
                chips={demoChips}
                value={selected}
                setValue={setSelected}
              />
            }
            value={selected}
          />
          <DemoComponent
            label='Readonly'
            component={
              <ChipSelector
                id='demo-chip-selector-readonly'
                title='Readonly'
                chips={demoChips}
                value={readonly}
                setValue={setReadonly}
                readOnly
              />
            }
            value={readonly}
          />
        </StyledDemoGrid>
      </SubSection>
    </>
  )
}
